import { media } from '@/styles/Qtheme';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

interface SubMissionTabProps<T> {
  currentSubMission: T;
  setCurrentSubMission: (subMission: T) => void;
  subMissions: T[];
}

const SubMissionTab = <T,>({
  currentSubMission,
  setCurrentSubMission,
  subMissions,
}: SubMissionTabProps<T>) => {
  const { t } = useTranslation();
  return (
    <Container>
      {subMissions.map((subMission) => (
        <Button
          isActive={currentSubMission === subMission}
          onClick={() => setCurrentSubMission(subMission)}
        >
          {t(subMission as string)}
        </Button>
      ))}
    </Container>
  );
};

export default SubMissionTab;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 50px;
`;

const Button = styled.button<{ isActive: boolean }>`
  cursor: pointer;
  color: ${({ isActive, theme }) =>
    isActive ? theme.COLORS.textw : theme.COLORS.tabMenuInactive};
  font-size: 26px;
  font-weight: 600;

  @media ${media.mobile} {
    font-size: 16px;
  }
`;
